<!--
 Created by Yaroslav S. on 10/07/2024
 Copyright © 2020 Curriculum Ltd. All rights reserved.
-->

<div class="mathpix-section">
  <div class="mathpix-section-title">Mathpix OCR</div>

  <div class="form-fields">
    <div class="form-fields-label">App ID</div>
    <curr-input
      [formGroup]="form"
      controlName="mathPixAppId"
      class="full-width form-field"
      [errorMessage]="form.controls['mathPixAppId'].hasError('required') ? 'App ID is required' : ''"
    ></curr-input>
  </div>

  <div class="form-fields">
    <div class="form-fields-label">Secret Key</div>
    <curr-input
      [formGroup]="form"
      controlName="mathPixApiKey"
      class="full-width form-field"
      [errorMessage]="form.controls['mathPixApiKey'].hasError('required') ? 'Secret Key is required' : ''"
    ></curr-input>
  </div>

  <curr-credits-error *ngIf="showError"></curr-credits-error>

  <div class="save-actions">
    <curr-button
      variant="contained"
      [isDisabled]="form.invalid || (!mathPixAppId.dirty && !mathPixApiKey.dirty)"
      (btnClick)="saveApiKey()"
      size="big"
      >SAVE</curr-button
    >
  </div>
</div>
